export const employeesRecordsTypes = [
  { key: 'salary_change', value: 'Изменение ЗП' },
  { key: 'business_trip', value: 'Командировка' },
  { key: 'bonus', value: 'Премия' },
  { key: 'hospital', value: 'Больничные' },
  { key: 'paid_vacation', value: 'Отпуск оплачиваемый' },
  { key: 'leave_without_pay', value: 'Отпуск без содержания' },
  { key: 'review_vacation', value: 'Отзыв из отпуска' },
  { key: 'dismissal', value: 'Увольнение' },
  // { key: 'compensation', value: 'Компенсация' },
];

export const employeesRecordsMap = {
  dismissal: 'Увольнение',
  salary_change: 'Изменение ЗП',
  paid_vacation: 'Отпуск оплачиваемый',
  leave_without_pay: 'Отпуск без содержания',
  hospital: 'Больничные',
  business_trip: 'Командировка',
  bonus: 'Премия',
  review_vacation: 'Отзыв из отпуска',
  compensation: 'Компенсация',
};
